import { css } from 'lit';

export const guildProfileViewStyles = css`

  :host {
    background: linear-gradient(
      180deg,
      var(--theme-color-primary-4, var(--teal-2)) 0,
      var(--view-gradient-end-color) 300px
    );
  }

  view-content {
    max-width: var(--q1-view-width);
  }

  /*=== HEADERS ===*/

  #title-header-bar {
    margin-bottom: 0;
    overflow: visible;
  }

  #title-header-bar sl-avatar  {
    --size: 5rem;
  }
  #title-header-bar sl-avatar::part(base)  {
    border: 3px solid var(--gray-4);
    transition: all 0.2s ease-in-out;
  }
  #title-header-bar sl-avatar:hover::part(base),
  #title-header-bar sl-avatar:focus::part(base) {
    box-shadow: var(--sl-shadow-large);
    border-width: 1px;
  }

  #member-title {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  #member-title h1 {
    margin: 0;
    font-size: 2rem;
    line-height: 1.3em;
  }

  a.title-link {
    text-decoration: none;
    --link-color-default: var(--theme-color-primary-9);
    --link-color-visited: var(--theme-color-primary-8);
    --link-color-focus: var(--theme-color-primary-7);
  }
  a.title-link:hover,
  a.title-link:focus {
    text-decoration: underline;
  }

  #member-details {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    color: var(--gray-6);
    font-weight: 400;
  }
  #member-details > span {
    display: flex;
    align-items: center;
    gap: 0.25rem;
  }

  #profile-header-bar button-bar {
    gap: 1rem;
  }

  #profile-header-bar a.prefix {
    --link-text-decoration-default: none;
    --link-text-decoration-focus: underline;
    --link-color-default: var(--gray-8);
    --link-color-visited: var(--gray-8);
    --link-color-focus: var(--gray-9);
  }

  /*=== GUILD PROFILE CONTENT ===*/

  guild-profile-content {
    display: block;
    background: white;
    box-shadow: var(--sl-shadow-small);
    padding: 2rem;
    
    margin: 0 -2rem;
    border-radius: 0;
  }
  @media(min-width: 650px) {
    guild-profile-content {
      margin: 0;
      border-radius: 12px;
    }
  }
  @media(min-width: 1000px) {
    guild-profile-content {
      padding: 2.5rem;
    }
  }

  guild-profile-content h1.main-header {
    margin: 0;
  }

  sl-tag.guild-profile-status::part(base) {
    background-color: color-mix(in hsl, var(--theme-color-secondary) 15%, transparent);
    color: var(--theme-color-secondary-6);
    border-color: var(--theme-color-secondary-4);
  }

  .guild-profile-status {
    float: right;
    margin: 0 0 1rem 1rem;
  }

  guild-profile-content p.subtitle.hero:last-child {
    margin-bottom: 0;
  }

  /*=== DETAILS PANEL ===*/

  #details-wrapper {
    display: flex;
    gap: 2rem;

    padding: 1rem 0;
    margin: 2rem 0;
    
    border-top: 1px solid var(--gray-2);
    border-bottom: 1px solid var(--gray-2);
    color: var(--gray-6);
    font-weight: 300;

    --link-color-default: var(--gray-6);
    --link-color-visited: var(--gray-6);
    --link-color-focus: var(--gray-9);
    --link-font-weight-default: 300;
    --link-text-decoration-default: none;
    --link-text-decoration-focus: none;
  }

  ul#details-panel {
    flex: 1 1 auto;

    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem 2rem;
    margin: 0;
    padding: 0;

    list-style: none;
  }

  ul#details-panel li {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
    padding: 0;
  }

  #details-actions {
    flex: 0 0 auto;

    display: flex;
    gap: 0.5rem;
    align-items: flex-start;
  }

  #details-actions a {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
  }

  /*=== PROPOSED VERSION PANEL ===*/

  proposed-version-panel {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    
    gap: 1rem 0.5rem;
    padding: 1rem;

    background: var(--gray-1);
    border: 1px solid var(--gray-3);
    border-radius: 5px;
  }
  proposed-version-panel .title {
    font-weight: 500;
  }
  proposed-version-panel .description {
    font-weight: 300;
    flex: 1 1 auto;
  }

  /*=== PROPOSE DIALOG ===*/

  #propose-dialog p.subtitle.hero {
    margin: 0 0 2rem 0;
  }

  #propose-dialog #role {
    margin-bottom: 2rem;
  }

  /*=== VERSION HISTORY ===*/

  q1-version-history {
    margin-top: calc(1.5 * var(--view-item-spacing));
  }

  q1-version-history::part(spinner) {
    --indicator-color: var(--theme-color-secondary);
  }
  
`;
